import { PersonalizedTheme } from '@itsrever/design-system'
import PortalFrame, { portalViews } from './portal-frame'
import {
  BrandingOverride,
  BrandingOverrideContext,
  EditedCopiesContext,
  PreviewDevice,
  PreviewDeviceContext,
  ThemeOverrideContext
} from './preview-contexts'

// Stable defaults: a fresh object literal per render would re-render every context consumer.
const NO_COPIES: Record<string, string> = {}

interface PortalPreviewProps {
  portalView: keyof typeof portalViews
  // Copy edits not saved yet, keyed "<LANG>-<copy_key>". Omit to preview the saved copies.
  copies?: Record<string, string>
  // Theme edits not saved yet. Omit to preview the saved e-commerce theme.
  theme?: PersonalizedTheme
  // Branding outside the theme shape (background text colour, logo box). Omit to preview stored.
  branding?: BrandingOverride
  // Which device the portal is drawn as. Defaults to the phone.
  device?: PreviewDevice
}

// The portal preview an editor mounts: it passes whatever it is editing and the providers are
// wired here, so no editor has to know which contexts the preview pages read.
export const PortalPreview = ({
  portalView,
  copies,
  theme,
  branding,
  device = 'mobile'
}: PortalPreviewProps) => (
  <ThemeOverrideContext.Provider value={theme ?? null}>
    <BrandingOverrideContext.Provider value={branding ?? null}>
      <EditedCopiesContext.Provider value={copies ?? NO_COPIES}>
        <PreviewDeviceContext.Provider value={device}>
          <PortalFrame portalView={portalView} device={device} />
        </PreviewDeviceContext.Provider>
      </EditedCopiesContext.Provider>
    </BrandingOverrideContext.Provider>
  </ThemeOverrideContext.Provider>
)

export default PortalPreview
